var initFreeMarkerMap = function(marker, lat, lng) {

    const initLat = lat || AppConfig.defaultMapCenter[0];
    const initLng = lng || AppConfig.defaultMapCenter[1];

    L.Icon.Default.imagePath = AppConfig.imagePath;
    const grayscale = L.tileLayer(MapSettings.urlFormat,
        { attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' });

    var roadPoints = [];

    var mymap = L.map("marker-map",
        {
            center: [initLat, initLng],
            zoom: AppConfig.defaultMapZoom,
            maxBounds: L.latLngBounds(AppConfig.defaultMapBounds[0], AppConfig.defaultMapBounds[1]),
            minZoom: AppConfig.defaultMapMinZoom,
            zoomReverse: true,
            layers: [grayscale]
        });

    mymap.on('click',
        function (e) {
            setPoint(e.latlng);
        });

    var data = {
        point: null,
        marker: null,
        map: mymap
    };

    if (lat && lng) {
        var point = L.latLng(lat, lng);
        setPoint(point);
    }

    function setPoint(point) {
        data.point = point;
        if (data.marker != null) {
            mymap.removeLayer(data.marker);
        }

        data.marker = L.marker(point).addTo(mymap);
    }

    return data;
};